"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var CreateButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CreateButton, _PureComponent);

  function CreateButton() {
    (0, _classCallCheck2.default)(this, CreateButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CreateButton).apply(this, arguments));
  }

  (0, _createClass2.default)(CreateButton, [{
    key: "renderButton",
    value: function renderButton() {
      var _this$props = this.props,
          labelLangKey = _this$props.labelLangKey,
          enabled = _this$props.enabled,
          onClick = _this$props.onClick;
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        onClick: onClick,
        disabled: !enabled
      }, _react.default.createElement(_UIIcon.default, {
        name: "add"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: labelLangKey
      }));
    }
  }, {
    key: "renderDisabledButton",
    value: function renderDisabledButton() {
      var disabledLangKey = this.props.disabledLangKey;
      return _react.default.createElement(_UITooltip.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: disabledLangKey
        })
      }, this.renderButton());
    }
  }, {
    key: "render",
    value: function render() {
      var enabled = this.props.enabled;
      return enabled ? this.renderButton() : this.renderDisabledButton();
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        labelLangKey: _react.PropTypes.string.isRequired,
        disabledLangKey: _react.PropTypes.string.isRequired,
        enabled: _react.PropTypes.bool.isRequired,
        onClick: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return CreateButton;
}(_react.PureComponent);

exports.default = CreateButton;
module.exports = exports.default;